export default __webpack_public_path__ + "static/media/image-cover.545b2bc2.jpg";